<template>
  <v-layout wrap row justify-center align-center no-gutters class="mt-6">
    <v-flex xs12 sm12 lg8 class="text-center pa-3">
      <h2 class="txt-primary">Accede rápidamente</h2>
    </v-flex>
    <v-flex xs12 sm10 lg8 d-flex row wrap justify-center class="ma-0 mt-1 pt-2">
      <!-- <v-card
    v-for="(item, i) in items" :key="'item-mdo-'+i"
    elevation="0"
    class="card-item ma-1 animate__animated animate__flipInY"
    :class="'animate__delay-'+i+'s'"
    >
      <v-icon class="card-item__icon" color="#2B5AC4"
      size="60px"
      >{{item.icon}}</v-icon>
      <h3 class="card-item__text mt-2">{{item.name}}</h3>
      <v-btn color="#1FB7FD"  class="btn-icon-modulo my-2" dark small fab elevation="0" @click="conoceMas(item.link)">
        <v-icon class="icon">mdi-arrow-right</v-icon>
         </v-btn>
    </v-card> -->

      <v-card v-for="(item, i) in items" :key="'item-mdo-' + i" elevation="0"
        class="card-item animate__animated animate__flipInY ma-1 mt-9" :class="'animate__delay-' + i + 's'"
        @click="conoceMas(item.link)">
        <div class="card-item__icon-b">
          <v-icon class="icon__item" size="40px">{{ item.icon }}</v-icon>
        </div>
        <h3 class="card-item__text mt-2">{{ item.name }}</h3>
        <!-- <v-btn color="#1FB7FD"  class="btn-icon-modulo my-2" dark small fab elevation="0" @click="conoceMas(item.link)">
      <v-icon class="icon">mdi-arrow-right</v-icon>
    </v-btn> -->
      </v-card>

    </v-flex>

  </v-layout>
</template>
<script>
export default {
  data () {
    return {
      items: [
        {
          name: 'Portal de niños',
          icon: 'mdi-robot-happy-outline',
          link: 'portalninos'
        },
        {
          name: 'Ventanilla Única',
          icon: 'mdi-microphone-outline',
          link: 'ventanilla'
        },
        // {
        //   name:'Conectividad',
        //   icon:'mdi-web',
        //   link:'',
        // },
        {
          name: 'PQRD',
          icon: 'mdi-chat-processing-outline',
          link: 'pqrd'
        },
        {
          name: 'Transparencia y Acceso a la Información',
          icon: 'mdi-file-find-outline',
          link: 'documentos'
        }

      ]
    }
  },
  methods: {
    conoceMas (val) {
      if (val == 'pqrd') {
        window.location.href = 'https://stage.eaav.gov.co/tipo_pqrd'
      } else if (val == 'ventanilla') {
        window.location.href = 'https://stage.eaav.gov.co/ventanilla_unica'
      } else if (val == 'portalninos') { window.open('https://portaldeninos.eaav.gov.co', '_blank') } else {
        // this.$router.push({name:val})
        this.$router.push({ name: val, params: { nameFiltro: 'na' } })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.card-item {
  padding: 5px 5px 10px 5px;
  width: 200px;
  text-align: center;
  color: #2B5AC4;
  box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.2) !important;
  border-radius: 10px;

  // @media screen and(max-width:600px) {
  //   width: 45vw;
  // }
  &:hover {
    transform: scale(1.05);

    .card-item__icon-b {
      transform: rotateY(360deg);
      // background: rgba(43,90,196,1);
      background: radial-gradient(circle, rgba(43, 90, 196, 1) 0%, rgba(89, 175, 244, 1) 100%);

      .icon__item {
        color: #F2F2F2;
      }
    }
  }

  h3 {
    font-size: 1.1em;
    line-height: 1em;
  }

  .card-item__icon-b {
    margin: 0 auto;
    width: 80px;
    height: 80px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 40px !important;
    // background: #F2F2F2;
    background: radial-gradient(circle, rgba(242, 242, 242, 1) 0%, rgba(242, 242, 242, 1) 100%);
    margin-top: -40px;
    transition: all 0.5s ease-in-out;
    box-shadow: 0px 15px 10px -15px #111;
  }

  .btn-icon-modulo {
    &:hover {
      transform: rotateZ(360deg);
    }
  }

  .icon__item {
    color: #2B5AC4;
  }
}
</style>
